/**
 * PrototypesOverview - вкладка прототипов: воронка + ретеншен с общим порогом регистраций
 * ========================================================================================
 *
 * Порог «мин. регистраций» скрывает проекты, у которых когорта за период (first_open) меньше порога,
 * сразу из таблиц и графиков обоих виджетов; на графике ретеншена по дням — ещё и дни установки с когортой
 * дня меньше порога. Фильтр на клиенте: данные проектов уже в ответе.
 */

import React, { useState } from 'react';
import { Input } from '../ui/input';
import { PrototypesFunnelWidget } from './PrototypesFunnelWidget';
import { PrototypesRetentionWidget } from './PrototypesRetentionWidget';

// Регистрации целые: дробный порог округляем вверх; пусто, отрицательное и мусор — без фильтра
function parseThreshold(raw) {
  const value = Number(raw);
  return Number.isFinite(value) && value > 0 ? Math.ceil(value) : 0;
}

export function PrototypesOverview() {
  const [rawThreshold, setRawThreshold] = useState('');
  const minRegistrations = parseThreshold(rawThreshold);

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <label
          htmlFor="prototypes-min-registrations"
          className="text-sm text-muted-foreground"
          title="Скрывает проекты, у которых регистраций (first_open) за весь период меньше порога"
        >
          Мин. регистраций
        </label>
        <Input
          id="prototypes-min-registrations"
          type="number"
          inputMode="numeric"
          min={0}
          step={1}
          placeholder="0"
          value={rawThreshold}
          onChange={(event) => setRawThreshold(event.target.value)}
          className="h-8 w-28"
        />
      </div>
      <PrototypesFunnelWidget minRegistrations={minRegistrations} />
      <PrototypesRetentionWidget minRegistrations={minRegistrations} />
    </div>
  );
}

export default PrototypesOverview;
